import { IconBolt } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';
import { getDataIdGenerator } from '../../../core/utils/generateDataId';
import { Button, Icon, IconButton, Modal } from '@hevoio/hevo-ui-toolkit';

declare const DASHBOARD_VERSION: string;

export function StaleVersionDetectionModal() {
  const [isOpen, setIsOpen] = useState(false);
  const [latestVersion, setLatestVersion] = useState<string | null>(null);

  useEffect(() => {
    const LAST_ACTIVE_KEY = "last_active_timestamp";

    const checkVersion = async () => {
      
        const res = await fetch(`/version.js?${Date.now()}`);
        const text = await res.text();
        const newVersion = text
          .split('=')[1]
          .split(';')[0]
          .replace(/(?:^\s*['"])|(?:['"]\s*$)/g, '') // remove spaces + quotes
          .trim();

        setLatestVersion(newVersion);

        if (newVersion && newVersion !== DASHBOARD_VERSION) {
          setIsOpen(true);
        }
      
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        const lastActive = parseInt(localStorage.getItem(LAST_ACTIVE_KEY) || "0", 10);
        const now = Date.now();

        // If inactive ≥ 1 day
        if (now - lastActive >=  24 * 60 * 60 * 1000) {
          checkVersion();
        }

        // Always update last active time
        localStorage.setItem(LAST_ACTIVE_KEY, String(now));
      }
    };

    // Set initial active time when component mounts
    localStorage.setItem(LAST_ACTIVE_KEY, String(Date.now()));

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  const bodyMessage = 'A new version of Hevo with performance improvements is available. Refresh your page to update. This does not impact your existing Pipelines.';
  const dataIdGenerator = getDataIdGenerator('stale-version-detection-modal', 'alert-dialog');

  return (
    <Modal
      open={isOpen}
      onClose={() => setIsOpen(false)}
      placement='center'
      styling={{ width: '470px', borderRadius: 'var(--border-radius-xl)' }}
    >
      <>
        <div className='dialog-header' tabIndex={0}>
          <div className='dialog-title' style={{ textTransform: 'none', fontWeight: 'var(--font-weight-medium)' }}>
            <div className='dialog-title-icon'>
              <IconBolt size={20} color='#335CFF' />
            </div>
            New version available
          </div>
          <IconButton label='close' dataId={dataIdGenerator('close')} onClick={() => setIsOpen(false)}>
            <Icon name='close' />
          </IconButton>
        </div>

        <div className='dialog-body alert-dialog-body'>{bodyMessage}</div>

        <div className='dialog-footer'>
          <Button dataId={dataIdGenerator('positive')} onClick={() => window.location.reload()}>
            Refresh
          </Button>
        </div>
      </>
    </Modal>
  );
}
